var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Layer } from 'bernie-view';
import { ExternalDialogBox } from './external-dialog-box';
var ExternalDialog = /** @class */function (_super) {
  __extends(ExternalDialog, _super);
  function ExternalDialog(props) {
    var _this = _super.call(this, props) || this;
    _this.setDialogBox = function (element) {
      _this.dialogBox = element;
    };
    _this.dialogBox = null;
    _this.state = {
      open: false
    };
    _this.openDialog = _this.openDialog.bind(_this);
    _this.closeDialog = _this.closeDialog.bind(_this);
    _this.updateDialog = _this.updateDialog.bind(_this);
    return _this;
  }
  ExternalDialog.prototype.componentDidMount = function () {
    window.addEventListener('external.dialog.open', this.openDialog);
    window.addEventListener('external.dialog.close', this.closeDialog);
    window.addEventListener('external.dialog.update', this.updateDialog);
  };
  ExternalDialog.prototype.componentWillUnmount = function () {
    window.removeEventListener('external.dialog.open', this.openDialog);
    window.removeEventListener('external.dialog.close', this.closeDialog);
    window.removeEventListener('external.dialog.update', this.updateDialog);
  };
  ExternalDialog.prototype.openDialog = function (event) {
    var detail = event.detail;
    var open = this.state.open;
    if (open) {
      this.updateDialog(event);
    } else {
      this.setState({
        open: true,
        detail: detail
      });
    }
  };
  ExternalDialog.prototype.closeDialog = function () {
    this.setState({
      open: false
    });
  };
  ExternalDialog.prototype.updateDialog = function (event) {
    var detail = event.detail;
    this.dialogBox.setDetails(detail);
  };
  ExternalDialog.prototype.render = function () {
    var _a = this.state,
      open = _a.open,
      detail = _a.detail;
    if (!open) {
      return null;
    }
    return React.createElement(Layer, {
      id: "external-dialog"
    }, React.createElement(ExternalDialogBox, __assign({
      ref: this.setDialogBox
    }, detail)));
  };
  return ExternalDialog;
}(React.Component);
export { ExternalDialog };